import { SVGProps } from "react";

export const TalentMarkBrandLegacy = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.6636 3.5L20.1851 11.3447L28.7329 12.2686L29.1431 13.5312L22.771 19.3037L24.5337 27.7197L23.4595 28.5L16.0005 24.2227L8.5415 28.5L7.46729 27.7197L9.229 19.3037L2.85693 13.5312L3.26709 12.2686L11.8159 11.3447L15.3364 3.5H16.6636ZM15.8892 17.3438C14.3034 17.344 13.0181 18.6291 13.0181 20.2148V21.2637C13.8269 21.7316 14.7642 22.0026 15.7642 22.0098H15.8462C16.9165 22.0021 17.9151 21.6924 18.7612 21.1621V20.2148C18.7612 18.6289 17.4751 17.3438 15.8892 17.3438ZM15.8892 12.1104C14.7 12.1106 13.736 13.0745 13.7358 14.2637C13.7358 15.453 14.6999 16.4177 15.8892 16.418C17.0786 16.418 18.0435 15.4531 18.0435 14.2637C18.0433 13.0744 17.0785 12.1104 15.8892 12.1104Z"
            fill="#1868DB"
        />
    </svg>
);
